import server from './server'
export default {
  readFileAsUrl (blob, cb) {
    const reader = new FileReader()
    reader.onload = () => {
      cb(reader.result)
    }
    reader.readAsDataURL(blob)
  },
  readFileAsByteArray (blob, cb) {
    const reader = new FileReader()
    reader.onload = () => {
      cb(reader.result)
    }
    reader.readAsArrayBuffer(blob)
  },
  convertToCsv (file, data, cb, cbErr) {
    if (/.*\.csv/i.test(file.name)) {
      cb(data)
      return
    }
    let fd = new FormData()
    fd.append('format', 'csv')
    fd.append('file', file)
    server.openApiPostConfig(
      '/openapi/converts',
      fd,
      {responseType: 'blob'},
      (blob) => {
        this.readFileAsByteArray(blob, (bytes) => {
          cb(bytes)
        })
      },
      (e) => {
        cbErr(e)
      })
  },
  notValidUtf (arr) {
    let result = false
    for (let i = 0; i < arr.length; i++) {
      if (((arr[i] & 0xE0) === 0xC0) &&
        !((i + 1 < arr.length) && (arr[i + 1] & 0xC0) === 0x80)) {
        result = true
        break
      }
      if (((arr[i] & 0xF0) === 0xE0) &&
       !((i + 2 < arr.length) && ((arr[i + 1] & 0xC0) === 0x80) && ((arr[i + 2] & 0xC0) === 0x80))) {
        result = true
        break
      }
      if (((arr[i] & 0xF8) === 0xF0) &&
       !((i + 3 < arr.length) && ((arr[i + 1] & 0xC0) === 0x80) && ((arr[i + 2] & 0xC0) === 0x80) && ((arr[i + 3] & 0xC0) === 0x80))) {
        result = true
        break
      }
    }
    return result
  },
  decode (bytes, codepage) {
    if (!bytes) {
      return ''
    }
    if (codepage) {
      return new TextDecoder(codepage).decode(bytes)
    }
    if (!this.notValidUtf(new Uint8Array(bytes))) {
      // No Rus win1251 symbols, looks like it is utf-8, not support more 2 byte unicode
      return new TextDecoder('UTF-8').decode(bytes)
    }
    return new TextDecoder('windows-1251').decode(bytes)
  },
  parseCsv (str) {
    // https://gist.github.com/Jezternz/c8e9fafc2c114e079829974e3764db75
    const csvStringToArray = (strData, delimiter) => {
      const objPattern = new RegExp((`(${delimiter}|\\r?\\n|\\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^${delimiter}\\r\\n]*))`), 'gi')
      let arrMatches = null
      let arrData = [[]]
      arrMatches = objPattern.exec(strData)
      while (arrMatches) {
        if (arrMatches[1].length && arrMatches[1] !== delimiter) {
          arrData.push([])
        }
        arrData[arrData.length - 1].push(arrMatches[2]
          ? arrMatches[2].replace(new RegExp('""', 'g'), '"')
          : arrMatches[3])
        arrMatches = objPattern.exec(strData)
      }
      return arrData
    }
    if (str) {
      const delimiterExpr = /,|;/g
      let delimiter = (str.search(delimiterExpr) >= 0) ? str[str.search(delimiterExpr)] : ','
      return csvStringToArray(str, delimiter)
    }
    return []
  },
  import (fields, data, dateFormat) {
    let map = []
    let keyField = null
    fields.forEach(f => {
      map[f.name] = f.number
      if (f.key || !keyField) {
        keyField = f.name
      }
    })
    const _g = (rec, name) => map[name] !== null ? rec[map[name]] : null
    const _n = (val) => {
      if (!val) return null
      val = val.replace(/\s/g, '')
      if (/,.*\.+/g.test(val)) {
        val = val.replace(/,/g, '')
      }
      if (!/,.*\.+/g.test(val)) {
        val = val.replace(/,/g, '.')
      }
      return Number(val)
    }
    const _d = (val) => {
      const formatDateToISO = (dateTime) => {
        return new Date(dateTime).toISOString().slice(0, 10)
      }
      if (!val) return null
      let v = val.trim()
      let result = null
      let ms = null
      switch (dateFormat) {
        case 'YYYY-MM-DD':
          ms = /^((?:19|20)\d\d)-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[0,1])$/.exec(v)
          result = ms ? `${ms[1]}-${ms[2]}-${ms[3]}` : null
          break
        case 'DD/MM/YYYY':
          ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\/(0[1-9]|1[012])\/((?:19|20)\d\d)$/.exec(v)
          result = ms ? `${ms[3]}-${ms[2]}-${ms[1]}` : null
          break
        case 'DD/MM/YY':
          ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\/(0[1-9]|1[012])\/(\d\d)$/.exec(v)
          result = ms ? `${'20' + ms[3]}-${ms[2]}-${ms[1]}` : null
          break
        case 'DD.MM.YYYY':
          ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\.(0[1-9]|1[012])\.((?:19|20)\d\d)$/.exec(v)
          result = ms ? `${ms[3]}-${ms[2]}-${ms[1]}` : null
          break
        case 'DD.MM.YY':
          ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\.(0[1-9]|1[012])\.(\d\d)$/.exec(v)
          result = ms ? `${'20' + ms[3]}-${ms[2]}-${ms[1]}` : null
          break
      }
      return result === formatDateToISO(result) ? result : null
    }
    let result = {}
    data.forEach((r, index) => {
      if (index !== 0 && _g(r, keyField)) {
        let item = {}
        fields.forEach(f => {
          switch (f.type) {
            case 'NUMBER': item[f.name] = _n(_g(r, f.name))
              break
            case 'DATE': item[f.name] = _d(_g(r, f.name))
              break
            default:
              item[f.name] = _g(r, f.name)
          }
        })
        result[_g(r, keyField) + ''] = item
      }
    })
    return result
  },
  errorFileMessage (file) {
    if (file && file.size && file.size >= 16777216) {
      return 'Поддерживаются файлы до 16Мб'
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/files.js